'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  return (
    <div className="bg-card rounded-xl shadow-soft p-6">
      <h3 className="text-lg font-headline font-semibold text-foreground mb-4">Categories</h3>
      <div className="space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-full flex items-center justify-between px-4 py-3 rounded-lg transition-all duration-300 ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground shadow-soft'
                : 'bg-muted/50 text-foreground hover:bg-muted'
            }`}
          >
            <div className="flex items-center space-x-3">
              <Icon
                name={category.icon as any}
                size={20}
                variant={activeCategory === category.id ? 'solid' : 'outline'}
              />
              <span className="font-medium">{category.name}</span>
            </div>
            <span className={`text-sm font-semibold ${
              activeCategory === category.id ? 'text-primary-foreground' : 'text-muted-foreground'
            }`}>
              {category.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;